
import React from 'react';
import styled from 'styled-components';
import { closeModal, openModal } from '../ducks';
import { connect } from 'react-redux';
import LicenceSelectorScreenContent from '../../../components/software_licence/licence_selector_screen_content';
import { getLicenceCategories } from '../../screens/licence_selector_screen/ducks';
import I10n from '../../i10n';
import Button from '../../../atoms/button';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 0px 16px;
  flex: 1 1 0px;
  max-width: 100%;
  box-sizing: border-box;
  overflow-y: auto;
`;

const NavigationButtonSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 10px 5px;
  border-top: 2px solid #EDEDED;
  background-color: white;
`;

const CancelWrapper = styled.div`
  margin-right: 10px;
`;

class LicenceSelectorScreen extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      licenceGroups: [],
      scopedLicences: {},
      availableLicenseModel: {},
      licencesLoading: false,
      selectedDisplayGroup: null,
    };
  }

  processLicenseGroupsWithCompatibilites = (licenceGroups) => {

    const forbiddenLicenseSelectors = this.props.hardwareToSoftwareCompatibilities.flatMap(compatibility => {
      return compatibility.forbiddenLicenseSelectorKeys;
    });

    const newLicenseGroups = [];
    for (const group of licenceGroups) {
      group.licenceTypes = group.licenceTypes.filter((type) => {
        return !forbiddenLicenseSelectors.includes(type.key);
      });

      if (group.licenceTypes.length > 0) {
        newLicenseGroups.push(group);
      }
    }

    return newLicenseGroups;
  }

  loadLicenseCategories = () => {
    this.updateStateIfMounted({licencesLoading: true, licenseDisplayGroups: []});
    getLicenceCategories(this.props.softwareSelection, this.licenseModel).then((licenceGroups) => {

      const groups = this.processLicenseGroupsWithCompatibilites(licenceGroups);

      const allLicences = [];
      const scopedLicences = {};
      const availableLicenseModel = {};
      const licenceTypesMap = {};
      for (const licenceGroup of (groups || [])) {
        for (const licenceType of (licenceGroup.licenceTypes || [])) {
          allLicences.push(...(licenceType.references || []));
          licenceTypesMap[licenceType.key] = licenceType;
          (licenceType.scopedReferences || []).forEach(l => {
            scopedLicences[l.id] = true;
          });
          (licenceType.allScopedReferences || []).forEach(l => {
            availableLicenseModel[l.licenseModel] = true;
          });
        }
      }

      const hardwareToSoftwareCompatibilities = (this.props.hardwareToSoftwareCompatibilities || []);
      if (hardwareToSoftwareCompatibilities.length > 0) {
        const candidateSelectors = [];

        hardwareToSoftwareCompatibilities.forEach(compatibility => {
          const licenseSelectorKey = compatibility.licenseSelectorKey;
          if (licenseSelectorKey && licenceTypesMap[licenseSelectorKey]) {
            candidateSelectors.push(licenseSelectorKey);
          }
        });

        if (candidateSelectors.length === 1) {
          this.openSelectorForLicenceType(licenceTypesMap[candidateSelectors[0]], (licences) => {
            this.addSoftwareLicences(licences, candidateSelectors[0]);
          });
        }
      }

      this.updateStateIfMounted({licenceGroups: groups, scopedLicences, availableLicenseModel});

    }).finally(() => {
      this.updateStateIfMounted({licencesLoading: false});
    });
  }

  componentDidMount = () => {
    this._isMounted = true;
    this.loadLicenseCategories();
  }

  componentWillUnmount = () => {
    this._isMounted = false;
  }

  updateStateIfMounted(state) {
    if (this._isMounted) {
      this.setState(state);
    }
  }

  computeLicenseLevel = () => {
    let result;
    for (let i = 0; i < (this.props.softwareLicences || []).length && result == null ; i++) {
      const softwareLicence = this.props.softwareLicences[i];
      if (softwareLicence.licenseLevel != null) {
        result = softwareLicence.licenseLevel;
      }
    }

    return result;
  }

  addSoftwareLicences = (licencesToAdd, selectorOrigin) => {
    this.props.addSoftwareLicences(licencesToAdd, selectorOrigin);
  }

  openSelectorForLicenceType = (licenceType, onSubmitCallback) => {
    const scopedLicences = {};
    (licenceType.scopedReferences || []).forEach(licence => {
      scopedLicences[licence.id] = true;
    });

    const startCriterias = [];
    this.props.hardwareToSoftwareCompatibilities.forEach(compatibility => {
      startCriterias.push(...(compatibility.startCriteria || []));
    });

    this.openSelectorModal(licenceType.key, scopedLicences, startCriterias, onSubmitCallback);
  }

  openSelectorModal = (licenceType, scopedLicences, startCriterias, onSubmitCallback) => {
    this.props.openModal({
      modalType: 'software-licence-selector',
      modalProps: {
        softwareLicences: this.props.softwareLicences,
        softwareSelection: this.props.softwareSelection,
        scopedLicences: scopedLicences,
        availableLicenseModel: this.state.availableLicenseModel,
        licenceType,
        startCriterias,
        licenseModel: this.props.licenseModel,
        licenseLevel: this.computeLicenseLevel(),
        onSubmit: (licencesToAdd) => {
          this.props.closeModal();
          onSubmitCallback(licencesToAdd);
        },
        windowModeEnabled: true,
      }
    });
  }

  removeSoftwareLicence = (licence, cancelCallback) => {

    this.props.openModal({
      modalType: 'confirmation',
      modalProps: {
        onCancel: () => { if (cancelCallback) { cancelCallback(); } this.props.closeModal(); },
        onSubmit: () => {
          this.props.closeModal();
          this.props.removeSoftwareLicence(licence);
        },
        title: I10n.get('screen.licence_selector.remove_licence.modal.title'),
        text: I10n.get('screen.licence_selector.remove_licence.modal.body'),
        cancelText: I10n.get('app.action.cancel'),
        submitText: I10n.get('app.action.continue'),
      }
    });
  }

  renderNavigationButtonSection = () => {
    return (
      <NavigationButtonSection>
        <CancelWrapper>
          <Button
            id='license-selector-screen-back-button'
            disabled={this.props.isSaving}
            onClick={event => {
              this.props.onPrevious();
            }}
          >
            {I10n.get('app.action.back')}
          </Button>
        </CancelWrapper>
        {this.props.softwareLicences?.length > 0 && <Button
          importance="emphasized"
          primary
          disabled={this.props.isSaving}
          onClick={event => {
            this.props.onContinue();
          }}>
            {I10n.get('app.action.continue')}
        </Button>}
      </NavigationButtonSection>
    );
  }

  render() {
    return (
      <>
        <Container>
          <LicenceSelectorScreenContent
            softwareSelection={this.props.softwareSelection}
            licenceGroups={this.state.licenceGroups}
            licenseLevel={this.computeLicenseLevel()}
            softwareLicences={this.props.softwareLicences}
            onAddSoftwareLicencesRequested={(licenceType) => {
              const licencesToAdd = [];
              (licenceType.scopedReferences || []).forEach(licence => {
                licencesToAdd.push({
                  id: licence.id,
                  quantity: 1
                });
              });

              const startCriterias = [];
              const hardwareToSoftwareCompatibilities = this.props.hardwareToSoftwareCompatibilities;
              if (hardwareToSoftwareCompatibilities) {
                hardwareToSoftwareCompatibilities.forEach(compatibility => {
                  startCriterias.push(...(compatibility.startCriteria || []));
                });
              }

              if (licenceType.openSelector) {
                this.openSelectorForLicenceType(licenceType, (licences) => {
                  this.addSoftwareLicences(licences, licenceType.key);
                });
              } else {
                this.addSoftwareLicences(licencesToAdd, licenceType.key);
              }
            }}
            removeSoftwareLicence={this.removeSoftwareLicence}
            setSoftwareLicenceQuantity={this.props.setSoftwareLicenceQuantity}
            licencesLoading={this.state.licencesLoading}
            configurationSaver={this.props.configurationSaver}
          ></LicenceSelectorScreenContent>
        </Container>
        {this.renderNavigationButtonSection()}
      </>
    );
  }
}

const mapStateToProps = state => {
  return state;
};

const mapDispatchToProps = dispatch => {
  return {
    openModal: (modalTypeWithProps) => dispatch(openModal(modalTypeWithProps)),
    closeModal: () => dispatch(closeModal())
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(LicenceSelectorScreen);
